export default "__VITE_ASSET__Cxn5yD4V__"